export default {
    TOGGLE_LOADING (state) {
        state.callingAPI = !state.callingAPI
    },
    TOGGLE_SEARCHING (state) {
        state.searching = (state.searching === '') ? 'loading' : ''
    },
    SET_USER (state, user) {
        state.user = user
    },
    SET_TOKEN (state, token) {
        state.token = token
    },
    SET_LIST_GOODS_FILTER (state, obj) {
        const keys = Object.keys(obj)
        state.listGoodsFilter = {}
        for (let i = 0; i < keys.length; i++) {
            state.listGoodsFilter[keys[i]] = obj[keys[i]]
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js